import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [status, setStatus] = useState('checking'); // checking, login-required, verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('No verification token provided');
      return;
    }

    if (!isAuthenticated) {
      setStatus('login-required');
      return;
    }

    // User is logged in, verify the email
    const verifyEmail = async () => {
      setStatus('verifying');
      try {
        const response = await axios.get(`/api/auth/verify-email/${token}`);
        if (response.data.success) {
          setStatus('success');
          setMessage(response.data.alreadyVerified 
            ? 'Your email was already verified.' 
            : 'Thank you for verifying your email!');
        }
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.error || 'Failed to verify your email. The link may be invalid or expired.');
      }
    };

    verifyEmail();
  }, [token, isAuthenticated]);

  const containerStyle = {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
  };

  const cardStyle = {
    background: 'white',
    padding: '40px',
    borderRadius: '12px',
    boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
    width: '100%',
    maxWidth: '450px',
    textAlign: 'center'
  };

  if (status === 'checking' || status === 'verifying') {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <h2 style={{ marginBottom: '20px', color: '#333' }}>Verifying Email...</h2>
          <p style={{ color: '#666' }}>Please wait while we verify your email address.</p>
        </div>
      </div>
    );
  }

  if (status === 'login-required') {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <h2 style={{ marginBottom: '20px', color: '#333' }}>Verify Your Email</h2>
          <p style={{ color: '#666', marginBottom: '20px' }}>
            Please log in to verify your email address.
          </p>
          <button
            onClick={() => navigate('/user')}
            className="btn btn-primary"
            style={{ width: '100%', marginBottom: '10px' }}
          >
            Go to Login
          </button>
          <p style={{ color: '#999', fontSize: '14px', marginTop: '15px' }}>
            After logging in, click the verification link again or return to this page.
          </p>
        </div>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={{ fontSize: '60px', marginBottom: '20px' }}>✓</div>
          <h2 style={{ marginBottom: '20px', color: '#28a745' }}>Email Verified!</h2>
          <p style={{ color: '#666', marginBottom: '20px' }}>{message}</p>
          <button
            onClick={() => navigate('/user')}
            className="btn btn-primary"
            style={{ width: '100%' }}
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  // Error state
  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={{ fontSize: '60px', marginBottom: '20px' }}>✗</div>
        <h2 style={{ marginBottom: '20px', color: '#dc3545' }}>Verification Failed</h2>
        <p style={{ color: '#666', marginBottom: '20px' }}>{message}</p>
        <button
          onClick={() => navigate('/user/account')}
          className="btn btn-primary"
          style={{ width: '100%', marginBottom: '10px' }}
        >
          Go to Account Settings
        </button>
        <p style={{ color: '#999', fontSize: '14px' }}>
          You can request a new verification email from your account settings.
        </p>
      </div>
    </div>
  );
};

export default VerifyEmail;

